<template>
    <div style="background: #e3f2fd;">
      <v-form ref="form" lazy-validation style="max-width: 60rem; margin:auto;padding: 1rem 0;">
        <v-card elevation="7" class="card-style">
          <v-card-title class="blue--text text-darken-2 font-weight-bold">Encuesta de Datos Personales</v-card-title>
          <v-divider class="my-4"></v-divider>
          <v-container>
            <!-- <v-card outlined>
              <v-card-title>Datos de encuestador</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-select v-model="pacienteData.usuario" label="Ingrese encuestador*" :items="arrayUsuario" required
                      :rules="[campoRequerido]" outlined item-text="usuario" item-value="usuario" dense></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card> -->
            <!-- Sección: Datos Personales -->
            <v-card outlined class="mt-5">
              <v-card-title>Datos personales</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="pacienteData.num_doc" label="Ingrese DNI del paciente*"
                      @keyup.enter="loadPaciente" required outlined dense :maxlength="8" :rules="[
                        (v) => !!v || 'Este campo es obligatorio',
                        (v) =>
                          /^[0-9]{8}$/.test(v) || 'Debe contener 8 dígitos numéricos',
                      ]"></v-text-field>
                    <v-btn @click="loadPaciente">Buscar</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.nombres" label="Nombres*" :rules="[campoRequerido]" required
                      outlined dense :disabled="pacienteHisar"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.ape_pat" label="Ape. Paterno*" :rules="[campoRequerido]" required
                      outlined dense :disabled="pacienteHisar"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.ape_mat" label="Ape. Materno*" :rules="[campoRequerido]" required
                      outlined dense :disabled="pacienteHisar"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.telefono" label="Celular*" :maxlength="9" :rules="[
                      (v) => !!v || 'Este campo es obligatorio',
                      (v) =>
                        /^[0-9]{9}$/.test(v) || 'Debe contener 9 dígitos numéricos',
                    ]" required outlined dense></v-text-field>
                  </v-col>
                </v-row>
                <!--  <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.telefonoAlterno" label="Celular Alterno" outlined
                      dense></v-text-field>
                  </v-col>
                </v-row> -->
              </v-card-text>
            </v-card>
  
            <!-- Sección: Datos Médicos -->
            <v-card outlined class="mt-5">
              <v-card-title>Datos médicos</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="pacienteData.clinica" :items="arrayClinica" label="Clínica*"
                      item-text="descripCas" item-value="id_cas" :rules="[campoRequerido]" outlined dense
                      required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select v-model="pacienteData.serologia" :items="arraySerologia" label="Serología*"
                      item-text="label" item-value="value" :rules="[campoRequerido]" outlined dense required></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="pacienteData.secuencia" :items="arraySecuencia" item-text="Secuencia"
                      item-value="url" label="Secuencia*" :rules="[campoRequerido]" outlined dense
                      required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="pacienteData.turno" :items="arrayTurno" item-text="Turno" item-value="url"
                      label="Turno*" :rules="[campoRequerido]" outlined dense required></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.medicoTurno" label="Médico nefrólogo de turno*" :rules="[campoRequerido]" outlined
                      dense required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.numeroMedico" label="Número de registro de especialista*" :rules="[campoRequerido]" outlined
                      dense required></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
  
            <!-- Sección: Ubicación Geográfica -->
            <v-card outlined class="mt-5">
              <v-card-title>Ubicación geográfica</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="pacienteData.departamento" :items="itemsDepartamento" label="Departamento*"
                      @change="loadProvincia" :rules="[campoRequerido]" outlined dense required
                      item-text="departamento"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="pacienteData.provincia" :items="itemsProvincia" label="Provincia*"
                      @change="loadDistrito" :rules="[campoRequerido]" outlined dense required
                      item-text="provincia"></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-autocomplete v-model="pacienteData.distrito" :items="itemsDistrito" label="Distrito*"
                      :rules="[campoRequerido]" outlined dense required item-text="distrito" item-value="ubigeo_reniec"
                      @change="updateMapLocation"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field v-model="pacienteData.direccion" label="Dirección*" :rules="[campoRequerido]" outlined
                      dense required></v-text-field>
                      <v-btn @click="updateMapLocationDireccion">Buscar</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="pacienteData.cordePacForm" label="Geolocalización (Latitud, Longitud)*"
                      :rules="[campoRequerido]" outlined dense required @change="updateMarkerPosition"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <!-- Botón para alternar pantalla completa -->
                    <v-btn @click="toggleFullscreen">
                      {{ isFullscreen ? "Reducir mapa" : "Ampliar mapa" }}
                    </v-btn>
                    <GmapMap :center="centerCoord" :zoom="12" :style="mapStyle">
                      <GmapMarker v-for="(marker, index) in marcadores" :key="index"
                        :position="{ lat: parseFloat(marker.posicion.lat), lng: parseFloat(marker.posicion.lng) }"
                        :clickable="true" :draggable="true" @dragend="onMarkerDragEnd(index, $event)" />
                    </GmapMap>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.tiempoTratamiento" :rules="[campoRequerido]"
                    label="¿Cuánto tiempo recibe tratamiento de hemodiálisis?" mandatory>
                    <v-radio label="0 a 1 año" value="0 a 1 año"></v-radio>
                    <v-radio label="1 a 5 años" value="1 a 5 años"></v-radio>
                    <v-radio label="Más de 5 años" value="Más de 5 años"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 2 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.distanciaCentro" :rules="[campoRequerido]"
                    label="¿Cuál es la distancia desde su casa al centro donde recibe tratamiento?" mandatory>
                    <v-radio label="0 a 5 kilómetros" value="0 a 5 kilómetros"></v-radio>
                    <v-radio label="5 a 10 kilómetros" value="5 a 10 kilómetros"></v-radio>
                    <v-radio label="Más de 10 kilómetros" value="Más de 10 kilómetros"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 3 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.tiempoLlegada" :rules="[campoRequerido]"
                    label="¿Cuánto tiempo le toma de salir de casa hasta llegar a su centro de tratamiento?" mandatory>
                    <v-radio label="0 a 30 minutos" value="0 a 30 minutos"></v-radio>
                    <v-radio label="30 a 60 minutos" value="30 a 60 minutos"></v-radio>
                    <v-radio label="Más de 60 minutos" value="Más de 60 minutos"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 4 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.gastoTransporte" :rules="[campoRequerido]"
                    label="¿Cuál es el gasto promedio que realiza en transporte por cada tratamiento?" mandatory>
                    <v-radio label="0 a 25 soles" value="0 a 25 soles"></v-radio>
                    <v-radio label="25 a 50 soles" value="25 a 50 soles"></v-radio>
                    <v-radio label="Más de 50 soles" value="Más de 50 soles"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 4 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.medioTransporte" :rules="[campoRequerido]"
                    label="¿En qué medio se transporta?" mandatory>
                    <v-radio label="Bus" value="Bus"></v-radio>
                    <v-radio label="Caminando" value="Caminando"></v-radio>
                    <v-radio label="Movilidad propia" value="Movilidad propia"></v-radio>
                    <v-radio label="Moto" value="Moto"></v-radio>
                    <v-radio label="Taxi" value="Taxi"></v-radio>
                    <v-radio label="Tren" value="Tren"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 4 -->
              <!--
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="pacienteData.medicoTurno" label="Médico nefrólogo de turno*" :rules="[campoRequerido]" outlined
                      dense required></v-text-field>
                </v-col>
              </v-row>
              -->
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 5 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.atencionCercana" :rules="[campoRequerido]"
                    label="¿Le gustaría ser atendido en una clínica más cerca a su domicilio?" mandatory>
                    <v-radio label="Sí" value="Sí"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                    <v-radio label="Tal vez" value="Tal vez"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
  
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 6 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.tipoAccesoVascular" :rules="[campoRequerido]"
                    label="Tipo de Acceso Vascular" mandatory>
                    <v-radio label="Catéter Venoso Central temporal" value="Catéter Venoso Central temporal"></v-radio>
                    <v-radio label="Catéter Venoso Central Tunelizado (Permanente)"
                      value="Catéter Venoso Central Tunelizado (Permanente)"></v-radio>
                    <v-radio label="Fístula Arteriovenosa" value="Fístula Arteriovenosa"></v-radio>
                    <v-radio label="Injerto Vascular" value="Injerto Vascular"></v-radio>
                    <v-radio label="Desconoce" value="Desconoce"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 7 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.medicacion" :rules="[campoRequerido]"
                    label="¿Le gustaría recibir toda su medicación en la clínica donde recibe el tratamiento de hemodiálisis?"
                    mandatory>
                    <v-radio label="Sí" value="Sí"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                    <v-radio label="Tal vez" value="Tal vez"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 8 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.terapia" :rules="[campoRequerido]"
                    label="¿Le informaron de la Terapia de Diálisis Peritoneal Domiciliaria?" mandatory>
                    <v-radio label="Sí" value="Sí"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
              <!-- Pregunta 8 -->
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="pacienteData.satisfaccion" :rules="[campoRequerido]"
                    label="¿En una escala de 0 a 10, donde 0 es insatisfecho total y 10 es completamente satisfecho, como calificaría la satisfacción que tiene usted de la clínica donde recibe su tratamiento de hemodiálisis?"
                    mandatory>
                    <v-radio label="0 a 3" value="0 a 3"></v-radio>
                    <v-radio label="4 a 6" value="4 a 6"></v-radio>
                    <v-radio label="7 a 10" value="7 a 10"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-card>
            <v-card outlined class="mt-5" style="padding: 0 1rem;">
            <!-- Pregunta 8 -->
            <v-row>
              <v-col cols="12">
                <!-- Checkbox para mostrar las alternativas -->
                <v-checkbox
                  v-model="mostrarOpciones"
                  label="Paciente no ubicado"
                ></v-checkbox>
                <!-- Opciones de satisfacción, visibles solo si mostrarOpciones es verdadero -->
                <v-radio-group
                  v-if="mostrarOpciones"
                  v-model="pacienteData.motivoFalta"
                  :rules="[campoRequerido]"
                  label="Motivo"
                  mandatory
                >
                  <v-radio label="Falta de presupuesto" value="Falta de presupuesto"></v-radio>
                  <v-radio label="Hospitalización " value="Hospitalización"></v-radio>
                  <v-radio label="Inasistencia comunicada" value="Inasistencia comunicada"></v-radio>
                  <v-radio label="Inasistencia no comunicada" value="Inasistencia no comunicada"></v-radio>
                  <v-radio label="Fallecimiento" value="Fallecimiento"></v-radio>
                  <v-radio label="Reprogramación" value="Reprogramación"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card>
            <v-card-actions style="margin: 1rem 0 0 0;color: white !important;">
              <v-btn color="blue" @click="enviar" style="color: white !important;">
                Enviar </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-form>
      <v-dialog v-model="dialogLoader" persistent width="300"
        style="padding: 1rem;overflow: hidden !important;background: white !important;">
        <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
      </v-dialog>
    </div>
  </template>
  <style scoped>
    .card-style {
      padding: 1rem 2rem;
    }
    
    ::v-deep .v-label.theme--light {
      font-size: 0.9rem;
    }
    
    .layout-loading {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      left: 0;
      pointer-events: none;
      position: fixed;
      top: 0;
      transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
      width: 100%;
      z-index: 202;
      background: #e3e3e3b1;
    }
    
    ::v-deep .v-dialog {
      display: flex;
      justify-content: center;
      box-shadow: none;
      overflow-y: hidden !important;
    }
    
    .swal2-shown.swal2-height-auto {
      padding: 0 !important;
    }
    
    .custom-swal-modal {
      width: 90%;
      /* Ajusta el ancho según tus necesidades */
      max-width: 400px;
      /* Ajusta el ancho máximo según tus necesidades */
    }
    
    .text-title-responsive {
      font-size: 1.7rem !important;
    }
    
    /* Estilos específicos para dispositivos móviles */
    @media (max-width: 600px) {
      .custom-swal-modal {
        width: 70%;
        /* Ajusta el ancho según tus necesidades para dispositivos móviles */
        max-width: 250px;
        /* Ajusta el ancho máximo según tus necesidades para dispositivos móviles */
      }
    }
    
    @media (max-width: 768px) {
      .card-style {
        padding: 1rem .3rem;
      }
    
      /* Puedes ajustar el tamaño máximo según tus necesidades */
      .mobile-error-modal {
        font-size: 14px;
        /* Tamaño de fuente más pequeño para el modal en móviles */
      }
    
      .mobile-error-icon {
        font-size: 10px !important;
        /* Tamaño de icono más pequeño para móviles */
      }
    
      .text-title-responsive {
        font-size: 1.1rem !important;
        line-height: 1.5;
      }
    }
  </style>
  <script>
  import Swal from "sweetalert2";
  import axios from "axios";
  export const RUTA_SERVIDOR = process.env.VUE_APP_API;
  export const USUARIO = process.env.VUE_APP_USERNAME;
  export const PASSWORD = process.env.VUE_APP_PASSWORD;
  export const RUTA_API = process.env.VUE_APP_API;
  export const API_KEY_DNI = process.env.VUE_API_KEY_DNI;

  export default {
    data: () => ({
      mostrarOpciones: false,
      dialogLoader: false,
      centerCoord: { lat: -12.074928851253814, lng: -77.04316187097396 },
      pacienteHisar: true,
      arraySecuencia: ['LUN-MIE-VIE', 'MAR-JUE-SAB', 'LUN-VIE', 'MAR-SAB'],
      arrayTurno: ['1', '2', '3', '4'],
      arraySerologia: ['Positivo', 'Negativo'],
      arrayClinica: [],
      numeroRules:
        v => /^[0-9]*$/.test(v) || 'El campo solo debe contener números',
      maxdat: 50,
      pacienteData: {
        usuario: '',
        nombres: '',
        ape_pat: '',
        ape_mat: '',
        telefono: '',
        telefonoAlterno: '',
        num_doc: '',
        serologia: '',
        clinica: '',
        secuencia: '',
        turno: '',
        departamento: '',
        provincia: '',
        distrito: '',
        direccion: '',
        cordePacForm: '',
        ubigeo_id: '',
        longitud: '',
        latitud: '',
        paciente_id: null,
        tiempoTratamiento: '',
        distanciaCentro: '',
        tiempoLlegada: '',
        gastoTransporte: '',
        atencionCercana: '',
        tipoAccesoVascular: '',
        medicacion: '',
        terapia: '',
        satisfaccion: '',
        medioTransporte:'',
        medicoTurno:'',
        numeroMedico:'',
        motivoFalta: null
      },
      valid: true,
      itemsTipSex: [
        { label: 'Masculino', value: 'M' },
        { label: 'Femenino', value: 'F' },
        { label: 'Otro', value: 'O' }
      ],
      dataMaesto: [], // Opciones para 'Tipo Doc'
      dataHospital: [], // Opciones para 'Hospital'
      dataMedico: [], // Opciones para 'Médico'
      itemsDepartamento: [], // Opciones para 'Departamento'
      itemsProvincia: [], // Opciones para 'Provincia'
      itemsDistrito: [], // Opciones para 'Distrito'
      campoRequerido: (v) => !!v || 'Este campo es obligatorio.',
      date: null, // Para 'Fecha de Nacimiento'
      menu: false, // Para el menú de calendario
      date1: null, // Para 'Fecha de última diálisis'
      menu1: false, // Para el segundo menú de calendario
      computedDateFormatted: '', // Formato de fecha de 'Fecha de Nacimiento'
      computedDateFormatted1: '', // Formato de fecha de 'Fecha de última diálisis'
      marcadores: [
        {
          posicion: { lat: -12.074928851253814, lng: -77.04316187097396 },
          nombre_completo: ''
        },
      ],
      dataPaciente: [],
      itemsUbigeo: [],
      itemsDepartamento: [],
      itemsDistrito: [],
      itemsProvincia: [],
      arrayUsuario: [],
      isFullscreen: false,         // Estado de pantalla completa
      initialStyle: { width: "100%", height: "320px" },  // Tamaño inicial
      fullscreenStyle: { width: "100%", height: "100vh" }, // Tamaño de pantalla completa
    }),
    methods: {
      async updateMapLocation() {
        const selectedDistrito = this.itemsDistrito.find(
          (distrito) => distrito.ubigeo_reniec === this.pacienteData.distrito
        );
        
        if (selectedDistrito) {
          // Construir dirección completa para geocodificar
          const address = `${selectedDistrito.distrito}, ${selectedDistrito.provincia}, ${selectedDistrito.departamento}, Perú`;
  
          // Llamada a la API de Google Geocoding para obtener las coordenadas
          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=AIzaSyDFpgJgnOCbehN1-KZNtYcWVc4_0uYiH8k`
            );
            const data = await response.json();
  
            if (data.results && data.results.length > 0) {
              const location = data.results[0].geometry.location;
              this.centerCoord = { lat: location.lat, lng: location.lng };
              /* this.markerPosition = { lat: location.lat, lng: location.lng }; */
              this.marcadores = [
                {
                  posicion: { lat: location.lat, lng: location.lng },
                  nombre_completo: ''
                },
              ]
            } else {
              console.error("No se encontraron resultados de geocodificación.");
            }
          } catch (error) {
            console.error("Error al obtener coordenadas:", error);
          }
        }
      },
      async updateMapLocationDireccion() {
        const selectedDistrito = this.itemsDistrito.find(
          (distrito) => distrito.ubigeo_reniec === this.pacienteData.distrito
        );
        
        if (selectedDistrito) {
          // Llamada a la API de Google Geocoding para obtener las coordenadas
          try {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(this.pacienteData.direccion)}&key=AIzaSyDFpgJgnOCbehN1-KZNtYcWVc4_0uYiH8k`
            );
            const data = await response.json();
  
            if (data.results && data.results.length > 0) {
              const location = data.results[0].geometry.location;
              this.centerCoord = { lat: location.lat, lng: location.lng };
              /* this.markerPosition = { lat: location.lat, lng: location.lng }; */
              this.marcadores = [
                {
                  posicion: { lat: location.lat, lng: location.lng },
                  nombre_completo: ''
                },
              ]
            } else {
              console.error("No se encontraron resultados de geocodificación.");
            }
          } catch (error) {
            console.error("Error al obtener coordenadas:", error);
          }
        }
      },
      toggleFullscreen() {
        // Alterna entre pantalla completa y tamaño inicial
        this.isFullscreen = !this.isFullscreen;
      },
      updateMarkerPosition() {
        const coords = this.pacienteData.cordePacForm
          .split(",")
          .map((coord) => parseFloat(coord.trim()));
        if (coords.length === 2) {
          /* this.markerPosition = { lat: coords[0], lng: coords[1] };  */// Actualiza la posición del marcador
          this.marcadores = [
            {
              posicion: { lat: coords[0], lng: coords[1] },
              nombre_completo: ''
            },
          ],
            this.centerCoord = { lat: coords[0], lng: coords[1] }; // Opcional: centra el mapa en la nueva posición
        }
      },
      loadPaciente() {
            this.auth = "Bearer " + 'apis-token-13227.EZwhdL4nu5JksFBEwIxSl3D49lVEmwtP';
            axios
            .get(RUTA_API + "/consultar-dni/", {
                params: {
                    numero: this.pacienteData.num_doc
                }
              },{
                headers: { Authorization: this.auth },
              })              
              .then((res) => {
                this.dataPaciente = res.data;
                console.log("Datos del paciente:", res.data);
                
                // Completar campos del formulario con los datos obtenidos
                if (res.data) {
                  this.pacienteData.nombres = res.data.nombres || '';
                  this.pacienteData.ape_pat = res.data.apellidoPaterno || '';
                  this.pacienteData.ape_mat = res.data.apellidoMaterno || '';
                  // El num_doc ya está establecido, pero se puede verificar con numeroDocumento
                  if (res.data.numeroDocumento) {
                    this.pacienteData.num_doc = res.data.numeroDocumento;
                  }
                }
                
              })
              .catch((res) => {
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El servicio no está disponible!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    popup: 'custom-swal-modal',
                    icon: 'mobile-error-icon'
                  }
                });
                console.log("Error:", res);
              });
      },
      loadDepartamentos() {
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios
              .post(RUTA_API + "/generar_lista_distrito/", {}, {
                headers: { Authorization: this.auth },
              })
              .then((res) => {
                this.itemsUbigeo = res.data;
                this.itemsDepartamento = res.data.filter((value, index, self) =>
                  index === self.findIndex((t) => (
                    t.departamento === value.departamento
                  ))
                );
              })
              .catch((res) => {
                this.dialog = false;
              });
          })
          .catch((response) => {
            response === 404
              ? console.warn("lo sientimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      },
      loadProvincia() {
        this.pacienteData.distrito = "";
        this.itemsDistrito = [];
        this.itemsProvincia = this.itemsUbigeo.filter(item =>
          item.departamento == this.pacienteData.departamento
        );
        if (this.dataPaciente[0]) {
          this.pacienteData.provincia = this.dataPaciente[0].provincia;
          this.loadDistrito();
        }
      },
      loadDistrito() {
        this.itemsDistrito = this.itemsUbigeo.filter(item =>
          item.provincia == this.pacienteData.provincia
        );
        if (this.dataPaciente[0]) {
          this.pacienteData.distrito = this.dataPaciente[0].ubigeo_id;
        }
      },
      onMarkerDragEnd(index, event) {
        // Obtiene las nuevas coordenadas del marcador
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        this.pacienteData.latitud = String(newLat);
        this.pacienteData.longitud = String(newLng);
        // Actualiza las coordenadas del marcador en la lista
        this.marcadores[index].posicion = { lat: newLat, lng: newLng };
        this.pacienteData.cordePacForm = `${newLat}, ${newLng}`;
        // Realiza cualquier otra acción necesaria con las nuevas coordenadas
        console.log('Nuevas coordenadas:', newLat, newLng);
      },
      loadClinicas() {
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios
              .post(RUTA_API + "/generar_lista_ipress/", { "tipoCas": 2 }, {
                headers: { Authorization: this.auth },
              })
              .then((res) => {
                this.arrayClinica = res.data;
              })
              .catch((res) => {
                this.dialog = false;
              });
          })
          .catch((response) => {
            response === 404
              ? console.warn("lo sientimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      },
      enviar() {
        this.pacienteData.motivoFalta = this.mostrarOpciones ? this.pacienteData.motivoFalta :"";
        /* console.log("Lista de pacientes enviados",this.pacienteData)
        return; */
        this.dialogLoader = true;
        // Validar que todos los campos obligatorios tengan contenido
        const camposObligatorios = [
          'usuario', 'num_doc', 'nombres', 'ape_pat', 'ape_mat', 'telefono',
          'clinica', 'serologia', 'secuencia', 'turno',
          'departamento', 'provincia', 'distrito', 'direccion',
          'cordePacForm','medicoTurno','numeroMedico'
        ];
  
        const camposVacios = camposObligatorios.filter(campo => !this.pacienteData[campo]);
  
        if (camposVacios.length > 0) {
          this.dialogLoader = false;
          Swal.fire({
            title: "¡Error!",
            text: "Por favor completa todos los campos obligatorios.",
            icon: "error",
            confirmButtonText: "Aceptar",
            customClass: {
              popup: 'custom-swal-modal',
              icon: 'mobile-error-icon'
            }
          });
          return;
        }
  
        this.pacienteData.ubigeo_id = this.pacienteData.distrito;
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios
              .post(RUTA_API + "/generar_ingresar_censo_paciente/", this.pacienteData, {
                headers: { Authorization: this.auth },
              })
              .then((res) => {
                this.actualizar();
                
              })
              .catch((res) => {
                this.dialogLoader = false;
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El servicio no está disponible!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    popup: 'custom-swal-modal',
                    icon: 'mobile-error-icon'
                  }
                });
                console.log("Error:", res);
              });
          })
          .catch((response) => {
            this.dialogLoader = false;
            Swal.fire({
              title: "¡Error!",
              text: "¡El servicio no está disponible!",
              icon: "error",
              confirmButtonText: "Aceptar",
              customClass: {
                popup: 'custom-swal-modal',
                icon: 'mobile-error-icon'
              }
            });
            response === 404
              ? console.warn("lo sientimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      },
      crearPacienteCupo(){
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios
              .post(RUTA_API + "/generar_crear_paciente_cupo/", 
              {
                num_doc :this.pacienteData.num_doc, 
                ape_pat : this.pacienteData.ape_pat, 
                ape_mat : this.pacienteData.ape_mat, 
                nombres : this.pacienteData.nombres, 
                hospital_id : 5, 
                latitud : this.pacienteData.latitud, 
                longitud : this.pacienteData.longitud, 
                turno : `TURNO ${this.pacienteData.turno}`,
                frecuencia : this.pacienteData.secuencia, 
                tipoPuesto :this.pacienteData.serologia,
                fecha_reg : new Date().toISOString().split('T')[0],
                cas_id : this.pacienteData.clinica
              }
              ,{
                headers: { Authorization: this.auth },
              })
              .then((res) => {
                Swal.fire({
                    title: "¡Aceptado!",
                    text: "¡El registro se realizó correctamente!",
                    icon: "success",
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar"
                  }).then((result) => {
                    // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  })
              })
              .catch((res) => {
                this.dialogLoader = false;
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El servicio no está disponible!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    popup: 'custom-swal-modal',
                    icon: 'mobile-error-icon'
                  }
                });
                console.log("Error:", res);
              });
          })
          .catch((response) => {
            this.dialogLoader = false;
            Swal.fire({
              title: "¡Error!",
              text: "¡El servicio no está disponible!",
              icon: "error",
              confirmButtonText: "Aceptar",
              customClass: {
                popup: 'custom-swal-modal',
                icon: 'mobile-error-icon'
              }
            });
            response === 404
              ? console.warn("lo sientimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      },
      actualizar() {
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios
              .post(RUTA_API + "/generar_actualizar_censo_paciente/", this.pacienteData, {
                headers: { Authorization: this.auth },
              })
              .then((res) => {
                this.dialogLoader = false;
                if(!this.pacienteHisar){
                  this.crearPacienteCupo();
                }else{
                  Swal.fire({
                    title: "¡Aceptado!",
                    text: "¡El registro se realizó correctamente!",
                    icon: "success",
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar"
                  }).then((result) => {
                    // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  })
                }
              })
              .catch((res) => {
                this.dialogLoader = false;
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El servicio no está disponible!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    popup: 'custom-swal-modal',
                    icon: 'mobile-error-icon'
                  }
                });
                console.log("Error:", res);
              });
          })
          .catch((response) => {
            this.dialogLoader = false;
            Swal.fire({
              title: "¡Error!",
              text: "¡El servicio no está disponible!",
              icon: "error",
              confirmButtonText: "Aceptar",
              customClass: {
                popup: 'custom-swal-modal',
                icon: 'mobile-error-icon'
              }
            });
            response === 404
              ? console.warn("lo sientimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      },
      clearForm() {
        this.pacienteData.paciente_id = null,
          this.pacienteData.nombres = '',
          this.pacienteData.ape_pat = '',
          this.pacienteData.ape_mat = '',
          this.pacienteData.telefono = '',
          this.pacienteData.telefonoAlterno = '',
          this.pacienteData.serologia = '',
          this.pacienteData.clinica = '',
          this.pacienteData.secuencia = '',
          this.pacienteData.turno = '',
          this.pacienteData.departamento = '',
          this.pacienteData.provincia = '',
          this.pacienteData.direccion = '',
          this.pacienteData.cordePacForm = '',
          this.pacienteData.ubigeo_id = '',
          this.pacienteData.longitud = '',
          this.pacienteData.latitud = ''
      },
      loadUsuarios() {
        axios
          .post(RUTA_API + "/api/token/", {
            username: USUARIO,
            password: PASSWORD,
          })
          .then((response) => {
            this.auth = "Bearer " + response.data.access;
            axios
              .post(RUTA_API + "/generar_lista_usuario_censo/", {}, {
                headers: { Authorization: this.auth },
              })
              .then((res) => {
                /* this.actualizar(); */
                this.arrayUsuario = res.data;
              })
              .catch((res) => {
                Swal.fire({
                  title: "¡Error!",
                  text: "¡El servicio no está disponible!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    popup: 'custom-swal-modal',
                    icon: 'mobile-error-icon'
                  }
                });
                console.log("Error:", res);
              });
          })
          .catch((response) => {
            response === 404
              ? console.warn("lo sientimos no tenemos servicios")
              : console.warn("Error:", response);
          });
      }
    },
    computed: {
      // Calcula el estilo del mapa según el estado de pantalla completa
      mapStyle() {
        return this.isFullscreen ? this.fullscreenStyle : this.initialStyle;
      }
    },
    created() {
      this.loadDepartamentos();
      this.loadClinicas();
      this.loadUsuarios();
    }
  };
  </script>